// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn_ec/v1/legacy_portal_common.proto (package spwn.spwn_ec.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * ライブコマース商品（Shopify の Product）
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceProduct
 */
export class LegacyPortalLiveCommerceProduct extends Message {
    constructor(data) {
        super();
        /**
         * Shopify の Product GID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string handle = 2;
         */
        this.handle = "";
        /**
         * @generated from field: string title = 3;
         */
        this.title = "";
        /**
         * @generated from field: string description_html = 4;
         */
        this.descriptionHtml = "";
        /**
         * 商品画像のURL一覧
         *
         * @generated from field: repeated string image_urls = 6;
         */
        this.imageUrls = [];
        /**
         * バリエーション一覧
         *
         * @generated from field: repeated spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant variants = 7;
         */
        this.variants = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalLiveCommerceProduct, a, b);
    }
}
LegacyPortalLiveCommerceProduct.runtime = proto3;
LegacyPortalLiveCommerceProduct.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceProduct";
LegacyPortalLiveCommerceProduct.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "featured_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "image_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "variants", kind: "message", T: LegacyPortalLiveCommerceProductVariant, repeated: true },
]);
/**
 * ライブコマースのカート（Shopify の Cart）
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceCart
 */
export class LegacyPortalLiveCommerceCart extends Message {
    constructor(data) {
        super();
        /**
         * `gid://shopify/Cart/<token>?key=<secret>` 形式。secret を含むので画面やログに出さない
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Shopify のホスト型チェックアウトへの URL
         *
         * @generated from field: string checkout_url = 2;
         */
        this.checkoutUrl = "";
        /**
         * @generated from field: int32 total_quantity = 3;
         */
        this.totalQuantity = 0;
        /**
         * 小計（円・整数。税と送料を含まない）
         *
         * @generated from field: int32 subtotal_amount = 4;
         */
        this.subtotalAmount = 0;
        /**
         * @generated from field: string currency_code = 5;
         */
        this.currencyCode = "";
        /**
         * @generated from field: repeated spwn.spwn_ec.v1.LegacyPortalLiveCommerceCartLine lines = 6;
         */
        this.lines = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceCart().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceCart().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceCart().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalLiveCommerceCart, a, b);
    }
}
LegacyPortalLiveCommerceCart.runtime = proto3;
LegacyPortalLiveCommerceCart.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceCart";
LegacyPortalLiveCommerceCart.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "checkout_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "subtotal_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lines", kind: "message", T: LegacyPortalLiveCommerceCartLine, repeated: true },
]);
/**
 * カートに入っている行
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceCartLine
 */
export class LegacyPortalLiveCommerceCartLine extends Message {
    constructor(data) {
        super();
        /**
         * Shopify の CartLine ID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Shopify の ProductVariant GID
         *
         * @generated from field: string merchandise_id = 2;
         */
        this.merchandiseId = "";
        /**
         * @generated from field: int32 quantity = 3;
         */
        this.quantity = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceCartLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceCartLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceCartLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalLiveCommerceCartLine, a, b);
    }
}
LegacyPortalLiveCommerceCartLine.runtime = proto3;
LegacyPortalLiveCommerceCartLine.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceCartLine";
LegacyPortalLiveCommerceCartLine.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchandise_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * フロントが「カートをこの内容にしたい」と指定する行
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceCartLineInput
 */
export class LegacyPortalLiveCommerceCartLineInput extends Message {
    constructor(data) {
        super();
        /**
         * Shopify の ProductVariant GID
         *
         * @generated from field: string merchandise_id = 1;
         */
        this.merchandiseId = "";
        /**
         * 0 を指定するとカートから取り除かれる
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceCartLineInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceCartLineInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceCartLineInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalLiveCommerceCartLineInput, a, b);
    }
}
LegacyPortalLiveCommerceCartLineInput.runtime = proto3;
LegacyPortalLiveCommerceCartLineInput.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceCartLineInput";
LegacyPortalLiveCommerceCartLineInput.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "merchandise_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * ライブコマース商品のバリエーション（Shopify の ProductVariant）
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant
 */
export class LegacyPortalLiveCommerceProductVariant extends Message {
    constructor(data) {
        super();
        /**
         * Shopify の ProductVariant GID。カート投入時の merchandise ID になる
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * 税込価格（円・整数）
         *
         * @generated from field: int32 price_amount = 3;
         */
        this.priceAmount = 0;
        /**
         * @generated from field: string currency_code = 4;
         */
        this.currencyCode = "";
        /**
         * @generated from field: bool available_for_sale = 5;
         */
        this.availableForSale = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalLiveCommerceProductVariant, a, b);
    }
}
LegacyPortalLiveCommerceProductVariant.runtime = proto3;
LegacyPortalLiveCommerceProductVariant.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant";
LegacyPortalLiveCommerceProductVariant.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "available_for_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "quantity_available", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map